import React, { useEffect, useState } from "react";
import { useTranslation } from "../contexts/LocaleContext";

const AddWhiteModal = ({
  isOpen,
  onClose,
  onSubmit,
  isLoading,
  initialData,
}) => {
  const { t } = useTranslation();
  const [form, setForm] = useState({
    id: "",
    urlOrAddress: "",
    description: "",
  });
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (isOpen) {
      if (initialData) {
        setForm({
          id: initialData.id ?? initialData._id ?? "",
          urlOrAddress: initialData.urlOrAddress ?? "",
          description: initialData.description ?? "",
        });
        setErrors({});
      } else {
        setForm({
          id: "",
          urlOrAddress: "",
          description: "",
        });
        setErrors({});
      }
    }
  }, [isOpen, initialData]);

  if (!isOpen) return null;

  const handleChange = (field, value) => {
    setForm((p) => ({ ...p, [field]: value }));
    // clear field error on change
    setErrors((e) => {
      const next = { ...e };
      delete next[field];
      return next;
    });
  };

  const handleSubmit = async (e) => {
    if (e && e.preventDefault) e.preventDefault();
    // client-side validation
    const newErrors = {};
    if (!String(form.urlOrAddress).trim())
      newErrors.urlOrAddress = t
        ? t("white.modal.url_required")
        : "URL or Address is required";

    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) return;

    if (onSubmit) {
      await onSubmit(form);
    }
  };

  return (
    <div className="modal-overlay" role="dialog" aria-modal="true">
      <div className="modal-card">
        <div className="modal-header">
          <h3>
            {form.id
              ? t
                ? t("white.modal.edit")
                : "Edit Whitelist"
              : t
              ? t("white.modal.add")
              : "Add Whitelist"}
          </h3>
          <button className="modal-close" onClick={onClose} aria-label="Close">
            ×
          </button>
        </div>

        <form className="modal-body" onSubmit={handleSubmit}>
          <div className="form-row">
            <label>
              <span className="label-icon" aria-hidden="true">
                <svg
                  t="1767854908259"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="31492"
                  width="200"
                  height="200"
                >
                  <path
                    d="M483.52 572.288a32 32 0 0 1-22.72-9.28c-72-72-72-154.24 0-226.24l67.84-67.84a160 160 0 0 1 226.24 226.24l-22.72 22.72a32 32 0 0 1-45.12-45.44l22.72-22.4a96.064 96.064 0 0 0-136-135.68l-67.84 67.84c-47.04 47.04-47.04 88.96 0 135.68a32 32 0 0 1-22.4 54.4z m-67.84 195.84a160 160 0 0 1-114.88-271.04l1.92-1.92a32.128 32.128 0 0 1 45.44 45.44 96 96 0 0 0 135.68 135.68l67.84-67.84a96 96 0 0 0 0-135.68 32 32 0 0 1 45.12-45.12 160 160 0 0 1 0 226.24l-67.84 67.84a160 160 0 0 1-113.28 46.4z"
                    fill="#000000"
                    p-id="31493"
                  ></path>
                </svg>
              </span>
              {t ? t("white.modal.url_label") : "URL or Address"}
            </label>
            <input
              value={form.urlOrAddress}
              onChange={(e) => handleChange("urlOrAddress", e.target.value)}
            />
            {errors.urlOrAddress && (
              <div className="form-error">{errors.urlOrAddress}</div>
            )}
          </div>

          <div className="form-row">
            <label>
              <span className="label-icon" aria-hidden="true">
                <svg
                  t="1767856979994"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="55455"
                  width="200"
                  height="200"
                >
                  <path
                    d="M917.390222 864.028444a31.971556 31.971556 0 1 1 0 63.943112h-768a31.971556 31.971556 0 1 1 0-64h768zM698.823111 105.244444l155.875556 155.875556a31.971556 31.971556 0 0 1 3.299555 41.415111l-3.299555 3.868445-441.230223 441.571555a32.028444 32.028444 0 0 1-22.698666 9.386667H234.723556a32.028444 32.028444 0 0 1-32.028445-32.028445v-155.306666c0-8.533333 3.413333-16.611556 9.386667-22.584889l441.457778-442.197334a32.881778 32.881778 0 0 1 45.283555 0z m-22.584889 68.266667l-409.6 409.6 0.056889 110.250667h110.933333l409.258667-409.6-110.648889-110.250667z"
                    fill="#000000"
                    p-id="55456"
                  ></path>
                </svg>
              </span>
              {t ? t("white.modal.description_label") : "Description"}
            </label>
            <input
              value={form.description}
              onChange={(e) => handleChange("description", e.target.value)}
            />
          </div>

          <div className="modal-actions">
            <button type="button" className="btn-ghost" onClick={onClose}>
              {t ? t("white.modal.cancel") : "Cancel"}
            </button>
            <button
              type="submit"
              className="btn-primary"
              disabled={
                isLoading ||
                Object.keys(errors).length > 0 ||
                !form.urlOrAddress
              }
            >
              {isLoading ? (
                <>
                  <span className="btn-spinner" aria-hidden="true" />
                  {t ? t("white.modal.save") : "Saving..."}
                </>
              ) : t ? (
                t("white.modal.save")
              ) : (
                "Save"
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddWhiteModal;
